import { render, staticRenderFns } from "./ProgramaSubir.vue?vue&type=template&id=b12d670e"
import script from "./ProgramaSubir.vue?vue&type=script&lang=js"
export * from "./ProgramaSubir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports